import { Injectable } from "@angular/core";
import { Arquivo } from "@tivic-team/manager-ts/dist/grl";
import { PagedResponse } from "app/interfaces/paged-response.inteface";
import { RecursoDTO } from "app/model/dtos/mob/recurso.dto";
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";

@Injectable()
export class RecursoController {

  constructor() { }

  async get(cdDocumento: number): Promise<RecursoDTO> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: 'mob/ait/recursos/:cdDocumento',
          environment: environment,
          pathParams: new JSONData({ cdDocumento: cdDocumento })
        }),
      }),
      new HttpResponse(
        new RecursoDTO
      )
    );
    return await quark.call();
  }

  async create(recursoDTO: RecursoDTO): Promise<RecursoDTO> {
    let quark = new Quark(
      new HttpPost({
        url: new Url({
          id: 'mob/ait/recursos',
          environment: environment
        }),
        data: new JSONData(recursoDTO)
      }),
      new HttpResponse(
        new RecursoDTO()
      )
    );
    return await quark.call();
  }

  async update(recursoDTO: RecursoDTO): Promise<RecursoDTO> {
    let quark = new Quark(
      new HttpPut({
        url: new Url({
          id: 'mob/ait/recursos/:cdDocumento',
          environment: environment,
          pathParams: new JSONData({ cdDocumento: recursoDTO.cdDocumento })
        }),
        data: new JSONData(recursoDTO)
      }),
      new HttpResponse(
        new RecursoDTO()
      )
    );
    return await quark.call();
  }

  async deferir(recursoDTO: RecursoDTO): Promise<RecursoDTO> {
    let quark = new Quark(
      new HttpPut({
        url: new Url({
          id: 'mob/ait/recursos/:cdDocumento/deferir',
          environment: environment,
          pathParams: new JSONData({ cdDocumento: recursoDTO.cdDocumento })
        }),
        data: new JSONData(recursoDTO)
      }),
      new HttpResponse(
        new RecursoDTO()
      )
    );
    return await quark.call();
  }

  async indeferir(recursoDTO: RecursoDTO): Promise<RecursoDTO> {
    let quark = new Quark(
      new HttpPut({
        url: new Url({
          id: 'mob/ait/recursos/:cdDocumento/indeferir',
          environment: environment,
          pathParams: new JSONData({ cdDocumento: recursoDTO.cdDocumento })
        }),
        data: new JSONData(recursoDTO)
      }),
      new HttpResponse(
        new RecursoDTO()
      )
    );
    return await quark.call();
  }

  async findArquivoRecurso(filtros?: IFilter): Promise<PagedResponse<Arquivo>> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: 'mob/ait/recursos',
          environment: environment,
          filter: filtros
        }),
      }),
      new HttpResponse(
        new Array<Arquivo>()
      )
    );
    return await quark.call();
  }

  downloadArquivo(cdArquivo: number): Promise<Arquivo> {
    let request = new Quark(
        new HttpGet({
            url: new Url({
                id: 'mob/ait/recursos/:cdArquivo/download',
                environment: environment,
                pathParams: new JSONData({
                    cdArquivo: cdArquivo
                }),
            }),
        }),
        new HttpResponse(new Arquivo())
    );

    return request.call();
}
  
}